import React, { useState, useEffect, useRef } from "react";
import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Moment from "react-moment";

//class BagMtow extends Component {
const tzeroClock = (props) => {
  var moment = require("moment");
  let flightDetail = props.flightDetail;
  let turnAroundTimeFinal = props.turnAroundTimeFinal;
  //console.info("bbdh", flightDetail);
  let offSet = props.serverOffSet;
  let depEdctDiffTime = props.depEdctDiffTime;

  //Countdown clock logic
  //Business rules as per Sep 27, 2019
  let MAX_TURNARDOUNT_TIME_MIN = props.max_TURNARDOUNT_TIME_MIN; //Default 45 min to start
  let remainingTimeToDep = MAX_TURNARDOUNT_TIME_MIN; //Before clock start ticking, remain time always equal to max time

  let inTime = flightDetail.InTime;

  let inTimeOutbound = flightDetail.InTimeOutbound;

  let outTime = flightDetail.OutTime;

  let yellowWarning = props.yellowWarning;
  //console.info("yellow warning tzero clock",yellowWarning);

  let finalDate = props.finalDate;

  let current = function () {
    return offSet + Date.now();
  };

  //This is the function that will update a bunch of elements according to their logic per sec
  //The reason to do this is to get the dynamic styling and content update with time
  function useInterval(callback, delay) {
    const savedCallback = useRef();

    // Remember the latest function.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
  }

  //Update current value constantly
  function CurrentRemainTime() {
    let [remainingTimeToDep, SetRemain] = useState();
    useInterval(() => {
      if (
        flightDetail &&
        flightDetail.UncorrectedTailNum &&
        flightDetail.UncorrectedTailNum.includes("-Y")
      ) {
        remainingTimeToDep = 0;
        SetRemain(0);
      } else {
        if (
          inTime == null &&
          outTime == null &&
          flightDetail.LegHashKeyInbound != null
        ) {
          remainingTimeToDep = MAX_TURNARDOUNT_TIME_MIN; //When in time is null, remain time always equal to max time
        } else if (outTime != null) {
          remainingTimeToDep = 0; //When out time exist, remaining time count to 0
        } else {
          remainingTimeToDep =
            flightDetail != null //When in time is not null, clock starts ticking, diff is calculated between max and current time
              ? moment(finalDate).diff(current(), "minutes")
              : 0;
        }
        if (remainingTimeToDep > 0) {
          SetRemain(Math.abs(remainingTimeToDep)); //Set final remain time in state
        }
      }
    }, 1000);
    //console.info("remaining time",remainingTimeToDep + " number"+ flightDetail.FltNumOutbound)
    return remainingTimeToDep;
  }

  //When off time is null, show label "estimate"
  function ShowEstimate() {
    let [estimateLabel, setEstimateLabel] = useState("");

    useInterval(() => {
      if (
        flightDetail &&
        flightDetail.UncorrectedTailNum &&
        flightDetail.UncorrectedTailNum.includes("-Y")
      ) {
        setEstimateLabel("");
      } else {
        if (flightDetail.OffTime != null && inTime == null) {
          //once the Off time is available, remove the 'estimate' label
          setEstimateLabel("Estimate"); //Set label "Estimate"
        } else {
          setEstimateLabel("");
        }
      }
    }, 1000);

    return <span>{estimateLabel}</span>;
  }

  //When the tzero clock has less than 5 minute, show "Gate closed" for "true t-zero clock"
  function GateClosed() {
    let [gateClosed, setGateClosed] = useState("");
    useInterval(() => {
      if (
        flightDetail &&
        flightDetail.UncorrectedTailNum &&
        flightDetail.UncorrectedTailNum.includes("-Y")
      ) {
        setGateClosed("");
      } else {
        remainingTimeToDep =
          flightDetail != null //Get remain time
            ? moment(finalDate).diff(current(), "minutes")
            : 0;
        if (
          remainingTimeToDep < yellowWarning &&
          (inTime != null || flightDetail.LegHashKeyInbound == null) &&
          outTime == null
        ) {
          //If remain time is less than 5 minutes
          setGateClosed("Close Doors"); //Set label
        } else if (outTime != null && flightDetail.TerminatorFlight < 1) {
          setGateClosed("Out of Gate");
        } else if (flightDetail.TerminatorFlight > 0) {
          setGateClosed("");
        }
      }
    }, 1000);
    return <span>{gateClosed}</span>;
  }

  //Style T0 clock into multiple colors in order to show status of urgency
  //Urgency code following global urgency color code: Red > Orange > Yellow > Green > Blue
  //Urgency level is updated every 15 min using  Red > Yellow > Blue

  function ClockStatClass() {
    let [finalStyle, setStyles] = useState("");
    useInterval(() => {
      remainingTimeToDep =
        flightDetail != null ? moment(finalDate).diff(current(), "minutes") : 0;

      //console.info("hbzhjhzhj", moment(finalDate).diff(current(), 'minutes') +"final date"+ finalDate
      // +"flight number" + flightDetail.FltNumOutbound);

      //console.info("answeer", moment(current(), 'minutes') );

      if (
        outTime == null ||
        (flightDetail.TerminatorFlight > 0 &&
          flightDetail.LastPaxOffTimeOutbound == null)
      ) {
        //console.info("flightDnumber" + flightDetail);
        if (
          remainingTimeToDep > 19 &&
          flightDetail.ModelOutbound == "DHC8-402"
        ) {
          // When T0 is above 20 min, show blue
          //console.info("flightDnumber" + flightDetail.FltNumOutbound +"remainingTimeToDep" + remainingTimeToDep);

          setStyles(
            buildStyles({
              backgroundColor: "#34495E",
              pathColor: "#ffffff ",
              trailColor: "#34495E",
            })
          );
        } else if (
          remainingTimeToDep > 29 &&
          flightDetail.ModelOutbound == "295"
        ) {
          // When T0 is above 30 min, show blue
          //console.info("flightDnumber" + flightDetail.FltNumOutbound + "remainingTimeToDep" + remainingTimeToDep);

          setStyles(
            buildStyles({
              backgroundColor: "#34495E",
              pathColor: "#ffffff ",
              trailColor: "#34495E",
            })
          );
        } else if (
          remainingTimeToDep <= 19 &&
          flightDetail.ModelOutbound == "DHC8-402" &&
          remainingTimeToDep > 4 &&
          (inTime != null || flightDetail.LegHashKeyInbound == null)
        ) {
          // When T0 is below 20 min, show yellow
          setStyles(
            buildStyles({
              backgroundColor: "#D8A800",
              pathColor: "#ffffff ",
              trailColor: "#D8A800",
            })
          );
        } else if (
          remainingTimeToDep <= 29 &&
          flightDetail.ModelOutbound == "295" &&
          remainingTimeToDep > 4 &&
          (inTime != null || flightDetail.LegHashKeyInbound == null)
        ) {
          // When T0 is below 30 min, show yellow
          setStyles(
            buildStyles({
              backgroundColor: "#D8A800",
              pathColor: "#ffffff ",
              trailColor: "#D8A800",
            })
          );
        } else if (
          remainingTimeToDep <= 5 &&
          (inTime != null || flightDetail.LegHashKeyInbound == null)
        ) {
          // Else show red
          //console.info("new requirements remainingTimeToDep", remainingTimeToDep +  "yellowwarning"+   yellowWarning
          // + "fltnum"+ flightDetail.FltNumOutbound)
          setStyles(
            buildStyles({
              backgroundColor: "#922B21",
              pathColor: "#ffffff ",
              trailColor: "#922B21",
            })
          );
        } else {
          setStyles(
            buildStyles({
              // Any other state will show blue
              backgroundColor: "#34495E",
              pathColor: "#ffffff ",
              trailColor: "#34495E",
            })
          );
        }
      } else {
        // If out time is null, plane is out of gate, show gray
        setStyles(
          buildStyles({
            backgroundColor: "#A6A6A6",
            pathColor: "#ffffff",
            trailColor: "#A6A6A6",
          })
        );
      }
    }, 1000);
    return finalStyle;
  }

  const clockFilter = (d) => {
    if ((d.match(/:/g) || []).length > 1) {
      //The output of moment component is a string, filter has to define whether the final string is hh:mm or mm:ss
      return moment.duration(d, "mm:ss").format("mm:ss"); //If hh:mm, return mm:ss
    } else {
      return d; //Otherwise return itself
    }
  };

  let clockDisplay = () => {
    if (flightDetail.UncorrectedTailNum.includes("-Y")) {
      //console.info("hbmjnmjdjd")
      return <div>Cancelled</div>;
    } else {
      if (flightDetail && flightDetail.TerminatorFlight > 0) {
        if (inTimeOutbound != null) {
          if (flightDetail.LastPaxOffTimeOutbound == null) {
            return (
              <span>
                <Moment
                  date={current()}
                  interval={1000}
                  duration={finalDate}
                  filter={clockFilter}
                />
              </span>
            );
          } else {
            return (
              <div>
                {
                  <Moment
                    date={moment(flightDetail.LastPaxOffTimeOutbound)}
                    duration={finalDate}
                  />
                }
              </div>
            );
          }
        } else {
          return <div>{MAX_TURNARDOUNT_TIME_MIN}m</div>;
        }
      } else {
        if (
          (inTime != null && outTime == null) ||
          flightDetail.LegHashKeyInbound == null
        ) {
          //When the inTime is not null, the clock start ticking
          if (outTime != null) {
            return (
              <span>
                <Moment
                  date={current()}
                  interval={1000}
                  duration={finalDate}
                  filter={clockFilter}
                />
              </span>
            );
          } else {
            return (
              <span>
                {
                  //console.info("nbzsdbh we",finalDate + "FltNumOutbound" +flightDetail.FltNumOutbound)
                }
                <Moment
                  date={current()}
                  interval={1000}
                  duration={finalDate}
                  filter={clockFilter}
                />
              </span>
            );
          }
        } else if (outTime != null) {
          return (
            <div>{<Moment date={moment(outTime)} duration={finalDate} />}</div>
          ); //When the outTime is not null, the clock stops ticking indicating the plane is out of the gate
        } else if (flightDetail.OffTime == null) {
          //console.info("nhfjdsj", MAX_TURNARDOUNT_TIME_MIN + " flt num" + flightDetail.FltNumOutbound)
          return <div>{MAX_TURNARDOUNT_TIME_MIN}</div>; //When the off time is null, show '--'
        } else {
          return <div>{MAX_TURNARDOUNT_TIME_MIN}m</div>; //When the clock is not ticking, show max time
        }
      }
    }
  };
  return (
    <CircularProgressbarWithChildren
      counterClockwise
      value={CurrentRemainTime()} //Render per sec for animation
      maxValue={Math.abs(MAX_TURNARDOUNT_TIME_MIN)} //Render at initialization
      background
      backgroundPadding={3} //Style is rendered per sec for immediate display
      styles={ClockStatClass()}
    >
      <div className="tCountdown">
        {ShowEstimate()}
        <div className="tRemain">{clockDisplay()}</div>
        {GateClosed()}
      </div>
    </CircularProgressbarWithChildren>
  );
};

export default tzeroClock;
